import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { environment } from '../../../environments/environment';
import { routerTransition } from '../../router.animations';

@Component({
  selector: 'app-tech',
  templateUrl: './tech.component.html',
  styleUrls: ['./tech.component.css'],
  animations: [routerTransition()],
  host: {'[@routerTransition]': ''}
})
export class TechComponent implements OnInit {
  technology: any;
  baseUrl: string = environment.baseUrl;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.technology = data.technology;
      if (this.technology.body) {
        this.technology.body = this.technology.body.replace(/\/cms/g, (this.baseUrl + '/cms'));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tech/tech.component.ts